const renderedComponents = {};

export default function(elements) {
  let isReviewsListLoaded = false;
  let isFullReviewsInitDone = false;

  function onRender(config, data) {
    if (config.component in renderedComponents) {
      return;
    }

    const powerReviewsId = config.page_id;
    const $parentDiv = $("[data-powerreviews='" + powerReviewsId + "']");
    renderedComponents[config.component] = true;

    if (!isReviewsListLoaded) {
      $('.buying-zone .pr-snippet-review-count').after($('.pr-separator'));
      $('.pr-snippet-review-count').text('');
      $('.pr-snippet-write-review-link').text($('.pr_reviews_no_reviews').val());
    }

    if ($('.pr-snippet-review-count').length && !isReviewsListLoaded) {
      isReviewsListLoaded = true;
      if (data.review_count > 0) {
        $('.pr-snippet-review-count').text(data.review_count + ' ' + $('.pr_reviews_header_text').val());
        $('.pr-snippet-write-review-link').text($('.pr_reviews_write_review').val());
      }
    }

    if ($('.pr-rating-stars').length || '.pr-snippet-review-count'.length) {
      scrollToReviews();
    }

    if (config.component === 'QuestionDisplay') {
      if (data.question_count !== 0) {
        const replyAuthorField = $parentDiv.find('span.pr-answer-by.pr-qa-display-answer-by.pr-subscript');
        // To fix unwanted span from the generated response.
        $('span.pr-answer-by.pr-qa-display-answer-by.pr-subscript').each(function() {
          const value = $(this)
            .text()
            .replace(/<span>/g, '')
            .replace('</span>', '')
            .trim();
          replyAuthorField.text(value);
        });
      }
    }

    $('.pr-review-snapshot-header-intro').addClass('hide');
    if (!$('#MyReviewHeader .pr-reviews-custom-header').length) {
      $('#MyReviewHeader').prepend(
        '<div class="pr-reviews-custom-header">' + $('.pr_reviews_header_text').val() + '</div>'
      );
    }

    const isProductArchived = $('#archivePdpFlag').val();
    const cannotWriteReviewText = $('#writeReviewText').val();

    // Overwrite "Write a review" text with "Cannot write a review" if the product is archived
    if (isProductArchived === 'true') {
      $('.pr-snippet-read-and-write')
        .find('.pr-separator')
        .first()
        .hide();
      $('.pr-snippet-write-review-link')
        .first()
        .attr('href', '#');
      $('.pr-snippet-write-review-link')
        .first()
        .attr('cursor', 'pointer');
      $('.pr-snippet-write-review-link')
        .first()
        .text(' ' + cannotWriteReviewText);
    }

    if ($('.pr-reviewsnippet .p-w-r').length > 1) {
      $('.pr-reviewsnippet .p-w-r:not(:first-child)').remove();
    }

    setTimeout(checkForQAHeader, 200);
  }

  // TBC-5159: The QA section gets re-rendered multiple times as the PowerReviews components are getting
  // loaded. Therefore the only way to make sure that jQuery manipulation is not undone is to set a
  // timeout and re-check header text after onRender is done
  function checkForQAHeader() {
    if ($('.pr-qa-display header h1 abbr').text() !== $('.pr_qa_header_text').val()) {
      setTimeout(checkForQAHeader, 200);
      $('.pr-qa-display header h1 abbr').text($('.pr_qa_header_text').val());
    }
  }

  function getPowerReviewsConfig(isRenderRatingStarsOnly) {
    const reviewConfigs = [];
    for (let i = 0; i < elements.length; i++) {
      const $reviewElement = $(elements[i]);
      const powerReviewsId = $reviewElement.find('.pr_page_id').val();
      const combinedCssTag = document.getElementById('mainCombinedCss');
      const combinedCssUrl = $(combinedCssTag).attr('href');

      let components;
      if (isRenderRatingStarsOnly) {
        components = {
          CategorySnippet: $('#pr-categorysnippet-' + powerReviewsId).length
            ? 'pr-categorysnippet-' + powerReviewsId
            : '',
          ReviewSnippet: $(document)
            .find('.pr-reviewsnippet')
            .attr('id'),
        };
      } else {
        components = {
          ReviewImageSnippet: $reviewElement.find('.pr-imagesnippet').attr('id'),
          ReviewDisplay: $reviewElement.find('.pr-reviewdisplay').attr('id'),
          QuestionDisplay: $reviewElement.find('.pr-questiondisplay').attr('id'),
        };
      }

      const reviewConfig = {
        api_key: $reviewElement.find('.pr_api_key').val(),
        locale: $reviewElement.find('.pr_locale').val(),
        merchant_group_id: $reviewElement.find('.pr_merchant_group_id').val(),
        merchant_id: $reviewElement.find('.pr_merchant_id').val(),
        page_id: powerReviewsId,
        review_wrapper_url: $reviewElement.find('.pr_write_review').val(),
        style_sheet: combinedCssUrl,
        on_render: onRender,
        components: components,
        product: {
          name: window.pr_product_name,
          url: window.pr_product_url,
          image_url: window.pr_product_image,
          description: window.pr_product_description,
          category_name: window.pr_product_category_name,
          manufacturer_id: window.pr_product_manufacturer_id,
          upc: window.pr_product_upc,
          brand_name: window.pr_product_brand_name,
          price: window.pr_product_price,
          in_stock: window.pr_product_in_stock,
        },
      };

      reviewConfigs.push(reviewConfig);
      return reviewConfigs;
    }
  }

  function isSectionInViewport() {
    const section = $('#MyReviewHeader');
    if (!section || !section.length) {
      return;
    }

    const viewPortTop = $(window).scrollTop();
    const viewPortBottom = viewPortTop + $(window).height();
    const sectionTop = section.offset().top;
    const sectionBottom = sectionTop + section.outerHeight();

    return sectionBottom > viewPortTop && sectionTop < viewPortBottom;
  }

  function performVisibilityCheck() {
    if (isFullReviewsInitDone) {
      return;
    }

    if (isSectionInViewport()) {
      document.removeEventListener('scroll', performVisibilityCheck);
      window.POWERREVIEWS.display.render(getPowerReviewsConfig(false));

      const section = $('#MyReviewHeader');
      section.find('.trek-loading-container').remove();
    }
  }

  function lazyInitReviewsSection() {
    document.addEventListener('scroll', performVisibilityCheck);
    setTimeout(performVisibilityCheck, 1000);
  }

  $(() => {
    const tryPowerReviews = setInterval(() => {
      if (window.POWERREVIEWS && $('.pr-reviewsnippet').length > 0) {
        window.POWERREVIEWS.display.render(getPowerReviewsConfig(true));
        lazyInitReviewsSection();
        clearInterval(tryPowerReviews);
      }
    }, 500);
  });

  function scrollToReviews() {
    $(document).on('click', '.pr-rating-stars, .pr-snippet-review-count', () => {
      if ($('a[href="#MyReviewHeader"]').length) {
        $('a[href="#MyReviewHeader"]').click();
      } else {
        $('html').animate(
          {
            scrollTop: $('#MyReviewHeader').offset().top,
          },
          800
        );
      }
    });
  }
}
